var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06567 6.02548C6.21318 7.28659 5 9.41147 5 11.8165C5 15.6825 8.13401 18.8165 12 18.8165C14.4051 18.8165 16.5299 17.6034 17.7911 15.7509C12.6817 15.1923 8.62421 11.1348 8.06567 6.02548ZM19 13.8166C19.866 13.8166 20.6118 14.5798 20.2691 15.3751C18.8898 18.5759 15.7066 20.8165 12 20.8165C7.02944 20.8165 3 16.7871 3 11.8165C3 8.10997 5.24067 4.92673 8.4414 3.54746C9.23674 3.20472 10 3.9505 10 4.81655C10 9.78712 14.0294 13.8166 19 13.8166Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/Dark.33a9ef7ef883e3e7c9185012f699d627.svg";
export { ForwardRef as ReactComponent };